'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProducts = undefined;

var _merchandiseAdapter = require('self-service-api/adapters/merchandiseAdapter');

var _merchandiseAdapter2 = _interopRequireDefault(_merchandiseAdapter);

var _noAuthApiClient = require('hub-http/clients/noAuthApiClient');

var _noAuthApiClient2 = _interopRequireDefault(_noAuthApiClient);

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _underscore = require('underscore');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchPublicMerchCatalog = (0, _underscore.memoize)(function (_ref) {
  var apiGetter = _ref.apiGetter;

  if (!apiGetter) {
    return _noAuthApiClient2.default.get('/self-service/v2/merchandise');
  }
  return new _q2.default.Promise(function (resolve, reject) {
    apiGetter.whenFinished(function (result) {
      resolve(result);
      window.quickFetch.removeEarlyRequest('merchandise');
    });
    apiGetter.onError(function (err) {
      reject(err);
      window.quickFetch.removeEarlyRequest('merchandise');
    });
  });
});

var getProducts = exports.getProducts = function getProducts(_ref2) {
  var apiGetter = _ref2.apiGetter;

  return fetchPublicMerchCatalog({
    apiGetter: apiGetter
  }).then(_merchandiseAdapter2.default);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/api/getProductsNoAuth.js
// module id = 887
// module chunks = 4